import { forwardRef, type SVGProps } from 'react';

export interface FileTreeIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const FileTreeIcon = forwardRef<SVGSVGElement, FileTreeIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 24 24">
    <path
      d="M12.727 6.75H3.75M3.75 1.5V17.25H12.75M19.5 10.5H12.75V2.25H16.8L19.5 5V10.5ZM19.5 21.75H12.75V13.5H16.8L19.5 16.25V21.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
));

FileTreeIcon.displayName = 'FileTreeIcon';
